import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import UpdateUserSurvey from "../mutations/UpdateUserSurvey";
import LikertInput from "./minorComponents/LikertInput";
import LikertInputCustom from "./minorComponents/LikertInputCustom";
import BooleanCustom from "./minorComponents/BooleanCustom";
import PlatformQuestion from "./minorComponents/PlatformQuestion";
import StringInput from "./minorComponents/StringInput";
import CurrentUserData from "../queries/CurrentUserData";
import GetSurvey from "../queries/GetSurvey";
import { useParams, useNavigate } from "react-router-dom";
// reactstrap components
import { Form, Button, Modal } from "reactstrap";
import { useAppContext } from "../AppContext";

const SurveySectionThree = ({ survey, currentUserData }) => {
  const params = useParams()
  const navigate = useNavigate()
  const [saveSurvey3] = useMutation(UpdateUserSurvey);

  const [showModal, setShowModal] = useState(false)
  const [variablesForModalClose, setVariablesForModalClose] = useState(null);
  const [errors, setErrors] = useState([]);

  const { displayToast, closeToast } = useAppContext();

  const handleMutation = (variables) => {
    return saveSurvey3({
      variables: variables,
      refetchQueries: [{ query: CurrentUserData },{ query: GetSurvey, variables: { surveyId: params.surveyId }}],
    })
      .then((result) => {
        console.log("Mutation result: ", result);
      })
      .catch((error) => {
        console.log("Mutation error:", error);
      });
  };

  const imi_questions = [
    {
      // BEGINNING OF SURVEY SPECIFIC
      type: "platformQuestion",
      default: null,
      table: "survey",
      text: "Please specify the platforms you used to access this module/assessment/posttest (check all that apply):",
      categories: [
        {
          text: "PC (Desktop/Laptop)",
          subcategories: [
            {
              key: "pc_edge",
              type: "singleToggle",
              text: "Microsoft Edge",
            },
            {
              key: "pc_chrome",
              type: "singleToggle",
              text: "Google Chrome",
            },
            {
              key: "pc_firefox",
              type: "singleToggle",
              text: "Mozilla Firefox",
            },
            {
              key: "pc_other",
              type: "string",
              text: "Other:",
              placeholder: "What other browsers did you use?",
            },
          ],
        },
        {
          text: "Mac (Desktop/Laptop)",
          subcategories: [
            {
              key: "mac_safari",
              type: "singleToggle",
              text: "Safari",
            },
            {
              key: "mac_chrome",
              type: "singleToggle",
              text: "Google Chrome",
            },
            {
              key: "mac_firefox",
              type: "singleToggle",
              text: "Mozilla Firefox",
            },
            {
              key: "mac_other",
              type: "string",
              text: "Other:",
              placeholder: "What other browsers did you use?",
            },
          ],
        },
        {
          text: "iOS Mobile Devices",
          subcategories: [
            {
              key: "ios_tablet",
              type: "singleToggle",
              text: "Tablet",
            },
            {
              key: "ios_smartphone",
              type: "singleToggle",
              text: "Smartphone",
            },
          ],
        },
        {
          text: "iOS Mobile Browsers",
          subcategories: [
            {
              key: "ios_safari",
              type: "singleToggle",
              text: "Safari",
            },
            {
              key: "ios_edge",
              type: "singleToggle",
              text: "Microsoft Edge",
            },
            {
              key: "ios_chrome",
              type: "singleToggle",
              text: "Google Chrome",
            },
            {
              key: "ios_firefox",
              type: "singleToggle",
              text: "Mozilla Firefox",
            },
            {
              key: "ios_other",
              type: "string",
              text: "Other:",
              placeholder: "What other browsers did you use?",
            },
          ],
        },
        {
          text: "Android Mobile Devices",
          subcategories: [
            {
              key: "android_tablet",
              type: "singleToggle",
              text: "Tablet",
            },
            {
              key: "android_smartphone",
              type: "singleToggle",
              text: "Smartphone",
            },
          ],
        },
        {
          text: "Android Mobile Browsers",
          subcategories: [
            {
              key: "android_edge",
              type: "singleToggle",
              text: "Microsoft Edge",
            },
            {
              key: "android_chrome",
              type: "singleToggle",
              text: "Google Chrome",
            },
            {
              key: "android_firefox",
              type: "singleToggle",
              text: "Mozilla Firefox",
            },
            {
              key: "android_other",
              type: "string",
              text: "Other:",
              placeholder: "What other browsers did you use?",
            },
          ],
        },
      ],
      key: "platformQuestion"
    },
    {
      key: "vpn",
      type: "boolean",
      default: false,
      table: "survey",
      text: "Are you accessing this part of the course through a Virtual Private Network (VPN)?",
      trueOption: "Yes",
      falseOption: "No",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "ease_of_access",
      type: "likert",
      default: null,
      text: "The courseware was easy to access.",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "ease_of_navigation",
      type: "likert",
      default: null,
      text: "It was easy to navigate through the module.",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "clear_instructions",
      type: "likert",
      default: null,
      text: "Instructions were clear and easy to follow, both in the target language and in English.",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "understood_expectation",
      type: "likert",
      default: null,
      text: "I understood what I was expected to know or be able to do at the end of the module.",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "interesting_manner",
      type: "likert",
      default: null,
      text: "The module content was presented in an interesting manner.",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "pe_realistic",
      type: "likert",
      default: null,
      text: "The practical exercise scenarios were realistic and job-relevant for the FAO audience.",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "pe_useful",
      type: "likert",
      default: null,
      text: "The practical exercises provided useful opportunity to practice applying terms and concepts introduced elsewhere in the module.",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "balance_pe_vs_course",
      type: "likert",
      default: null,
      text: "There was an appropriate balance between time spent on practical exercises and on other kinds of learning activities (e.g., readings, vocabulary exercises, etc.).",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "instructions_appropriate",
      type: "likert",
      default: null,
      text: "The overall level of the instruction seemed appropriate for FAOs at an ILR Level of 3/3/2, minimum 2/2/2.",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "reading_listening_appropriate",
      type: "likert",
      default: null,
      text: "The reading/listening activities were appropriate for the FAO audience.",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "time_taken",
      type: "likertInputCustom",
      default: null,
      text: "The time it took me to complete this module was:",
      fields: [
        // custome likert will need an array of fields, the text can be changed when ever if a spelling error and can add/remove new values as needed. DO NOT CHANGE VALUE OR ALREADY ANSWERED WILL BE LOST UNLESS YOU'RE SURE
        { text: "Less than 4 hours", value: "<4" },
        { text: "4 to less than 5 hours", value: "4-5" },
        { text: "5 to less than 6 hours", value: "5-6" },
        { text: "6 to less than 7 hours", value: "6-7" },
        { text: "7 or more hours", value: ">7" },
      ],
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "module_length",
      type: "likertInputCustom",
      default: null,
      text: "The module was:",
      fields: [
        // custome likert will need an array of fields, the text can be changed when ever if a spelling error and can add/remove new values as needed. DO NOT CHANGE VALUE OR ALREADY ANSWERED WILL BE LOST UNLESS YOU'RE SURE
        { text: "Too Long", value: "too_long" },
        { text: "Too Short", value: "too_short" },
        { text: "About Right", value: "about_right" },
      ],
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "overall_assessment",
      type: "likertInputCustom",
      default: null,
      text: "My overall assessment of the module is:",
      fields: [
        // custome likert will need an array of fields, the text can be changed when ever if a spelling error and can add/remove new values as needed. DO NOT CHANGE VALUE OR ALREADY ANSWERED WILL BE LOST UNLESS YOU'RE SURE
        { text: "Excellent", value: "excellent" },
        { text: "Good", value: "good" },
        { text: "Average", value: "average" },
        { text: "Fair", value: "fair" },
        { text: "Poor", value: "poor" },
      ],
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "recommendations",
      type: "string",
      default: "",
      text: "What recommendations do you have for making this module more effective? (Please make your suggested changes as specific as you can.)",
    },
    {
      key: "observations",
      type: "string",
      default: "",
      text: "What observations do you have about this module or the method in which it was delivered that have not been addressed by other questions?",
    },
    {
      key: "improved_proficiency",
      type: "likert",
      default: null,
      text: "This module will improve my language proficiency.",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "improved_job_performance",
      type: "likert",
      default: null,
      text: "This module will improve my language-related job performance.",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "challenging_aspects",
      type: "string",
      default: "",
      text: "What were the most challenging aspects or sections of the module?",
    },
    {
      key: "most_useful",
      type: "string",
      default: "",
      text: "What part(s) of the module seem most useful to you in your position as a FAO?",
    },
    {
      key: "least_useful",
      type: "string",
      default: "",
      text: "What part(s) of the module seem least useful to you in your position as a FAO?",
    },
  ];

  const test_questions = [
    {
      // BEGINNING OF SURVEY SPECIFIC
      type: "platformQuestion",
      default: null,
      table: "survey",
      text: "Please specify the platforms you used to access this module/assessment/posttest (check all that apply):",
      categories: [
        {
          text: "PC (Desktop/Laptop)",
          subcategories: [
            {
              key: "pc_edge",
              type: "singleToggle",
              text: "Microsoft Edge",
            },
            {
              key: "pc_chrome",
              type: "singleToggle",
              text: "Google Chrome",
            },
            {
              key: "pc_firefox",
              type: "singleToggle",
              text: "Mozilla Firefox",
            },
            {
              key: "pc_other",
              type: "string",
              text: "Other:",
              placeholder: "What other browsers did you use?",
            },
          ],
        },
        {
          text: "Mac (Desktop/Laptop)",
          subcategories: [
            {
              key: "mac_safari",
              type: "singleToggle",
              text: "Safari",
            },
            {
              key: "mac_chrome",
              type: "singleToggle",
              text: "Google Chrome",
            },
            {
              key: "mac_firefox",
              type: "singleToggle",
              text: "Mozilla Firefox",
            },
            {
              key: "mac_other",
              type: "string",
              text: "Other:",
              placeholder: "What other browsers did you use?",
            },
          ],
        },
        {
          text: "iOS Mobile Devices",
          subcategories: [
            {
              key: "ios_tablet",
              type: "singleToggle",
              text: "Tablet",
            },
            {
              key: "ios_smartphone",
              type: "singleToggle",
              text: "Smartphone",
            },
          ],
        },
        {
          text: "iOS Mobile Browsers",
          subcategories: [
            {
              key: "ios_safari",
              type: "singleToggle",
              text: "Safari",
            },
            {
              key: "ios_edge",
              type: "singleToggle",
              text: "Microsoft Edge",
            },
            {
              key: "ios_chrome",
              type: "singleToggle",
              text: "Google Chrome",
            },
            {
              key: "ios_firefox",
              type: "singleToggle",
              text: "Mozilla Firefox",
            },
            {
              key: "ios_other",
              type: "string",
              text: "Other:",
              placeholder: "What other browsers did you use?",
            },
          ],
        },
        {
          text: "Android Mobile Devices",
          subcategories: [
            {
              key: "android_tablet",
              type: "singleToggle",
              text: "Tablet",
            },
            {
              key: "android_smartphone",
              type: "singleToggle",
              text: "Smartphone",
            },
          ],
        },
        {
          text: "Android Mobile Browsers",
          subcategories: [
            {
              key: "android_edge",
              type: "singleToggle",
              text: "Microsoft Edge",
            },
            {
              key: "android_chrome",
              type: "singleToggle",
              text: "Google Chrome",
            },
            {
              key: "android_firefox",
              type: "singleToggle",
              text: "Mozilla Firefox",
            },
            {
              key: "android_other",
              type: "string",
              text: "Other:",
              placeholder: "What other browsers did you use?",
            },
          ],
        },
      ],
      key: "platformQuestion"
    },
    {
      key: "vpn",
      type: "boolean",
      default: false,
      table: "survey",
      text: "Are you accessing this part of the course through a Virtual Private Network (VPN)?",
      trueOption: "Yes",
      falseOption: "No",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "ease_of_access",
      type: "likert",
      default: null,
      text: "The module assessment (or course posttest) was easy to access.",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "ease_of_navigation",
      type: "likert",
      default: null,
      text: "It was easy to navigate through the module assessment (or course posttest).",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "clear_instructions",
      type: "likert",
      default: null,
      text: "Instructions for the module assessment (or course posttest) questions were clear and easy to follow, both in the target language and in English.",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "focused_on_material",
      type: "likert",
      default: null,
      text: "The module assessment (or course posttest) focused on content that was taught in the associated module.",
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "module_length",
      type: "likertInputCustom",
      default: null,
      text: "The module assessment (or course posttest) was:",
      fields: [
        // custome likert will need an array of fields, the text can be changed when ever if a spelling error and can add/remove new values as needed. DO NOT CHANGE VALUE OR ALREADY ANSWERED WILL BE LOST UNLESS YOU'RE SURE
        { text: "Too Long", value: "too_long" },
        { text: "Too Short", value: "too_short" },
        { text: "About Right", value: "about_right" },
      ],
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "overall_assessment",
      type: "likertInputCustom",
      default: null,
      text: "My overall evaluation of the module assessment (or course posttest) is:",
      fields: [
        // custome likert will need an array of fields, the text can be changed when ever if a spelling error and can add/remove new values as needed. DO NOT CHANGE VALUE OR ALREADY ANSWERED WILL BE LOST UNLESS YOU'RE SURE
        { text: "Excellent", value: "excellent" },
        { text: "Good", value: "good" },
        { text: "Average", value: "average" },
        { text: "Fair", value: "fair" },
        { text: "Poor", value: "poor" },
      ],
      required: true,
      errorText: "Please make a selection.",
    },
    {
      key: "recommendations",
      type: "string",
      default: "",
      text: "What recommendations do you have for making this assessment (or posttest) more effective? (Please make your suggested changes as specific as you can.)",
    },
    {
      key: "observations",
      type: "string",
      default: "",
      text: "What observations do you have about this assessment (or posttest) or the method in which it was delivered that have not been addressed by other questions?",
    },
  ];

  const [values, setValues] = useState(() => {
    return initializeValues();
  });


  function initializeValues() {
    let newValues = {};
    if (
      typeof survey.survey_type === "undefined" ||
      survey.survey_type === null ||
      survey.survey_type === "imi" ||
      survey.survey_type === "introduction"
    ) {
      imi_questions.forEach((question, index) => {
        if (question.type === "platformQuestion") {
          question.categories.forEach((category, cIndex) => {
            category.subcategories.forEach((subcategory, sIndex) => {
              newValues[subcategory.key] = survey[subcategory.key];
            });
          });
        } else {
          newValues[question.key] = survey[question.key];
        }
      });
    } else {
      test_questions.forEach((question, index) => {
        if (question.type === "platformQuestion") {
          question.categories.forEach((category, cIndex) => {
            category.subcategories.forEach((subcategory, sIndex) => {
              newValues[subcategory.key] = survey[subcategory.key];
            });
          });
        } else {
          newValues[question.key] = survey[question.key];
        }
      });
    }
    return newValues;
  }

  function showToast(success, message) {
    const toast = {
      title: success ? "Success" : "Error",
      color: success ? "bg-success" : "bg-danger",
      icon: success ? "check-bold" : "fat-remove",
      message
    }

    displayToast(toast)

    setTimeout(() => {
      closeToast()
    }, 10000)
  }

  function onSubmit() {
    let newErrors = [];
    let variables = { surveyId: survey.id };
    let questionsToCheck = [];
    // if for some reason survey type is null then assume IMI
    if (survey.survey_type === null || survey.survey_type === "imi" || survey.survey_type === "introduction") {
      questionsToCheck = imi_questions;
    } else {
      questionsToCheck = test_questions;
    }

    questionsToCheck.forEach((question, index) => {
      if (question.required && (typeof values[question.key] == "undefined" || values[question.key] == null)) {
        newErrors.push({ name: question.key, text: question.errorText });
      } else if(question.type === "platformQuestion") {
        let chosen = null
        question.categories.forEach((category, cIndex) => {
          category.subcategories.forEach((subcategory, sIndex) => {
            if(typeof values[subcategory.key] !== "undefined" && values[subcategory.key] !== null && values[subcategory.key] !== null && values[subcategory.key] !== false && values[subcategory.key] !== "") {
              chosen = subcategory.key
            }
          });
        });
        
        if(chosen == null) {
          newErrors.push({name: "platformQuestion", text: "Please select at least thing you used"})
        }
      }

      if (question.type === "platformQuestion") {
        question.categories.forEach((category, cIndex) => {
          category.subcategories.forEach((subcategory, sIndex) => {
            variables[subcategory.key] = values[subcategory.key];
          });
        });
      } else {
        variables[question.key] = values[question.key];
      }
    });

    setErrors(newErrors);

    if (newErrors.length === 0) {
      const dateToStore = new Date();
      variables["section_3_completed_date"] = JSON.stringify(dateToStore);
    } else {
      variables["section_3_completed_date"] = "";
    }

    // possible situations upon submission.
    // All fields are answered and the other survey is done
    // All fields are answered but the other survey is NOT done
    // not all fields are answered but the other survey is done
    // Not all fields are answered and the other survey is NOT done
    if(currentUserData.section_1_completed_date !== null && variables["section_3_completed_date"] !== "") {
      setShowModal(true)
      setVariablesForModalClose(variables)
    } else if(variables["section_3_completed_date"] !== "") {
      // this survey is complete but other one isn't
      handleMutation(variables)
        .then(() => {
          showToast(true, "You have completed and saved this section. Please select another section at the top of this page.")
        })
      setVariablesForModalClose(null)
    } else if(currentUserData.section_1_completed_date !== null) {
      // this survey has missing answers but the other one is completed
      handleMutation(variables)
        .then(() => {
          showToast(false, "Your answers are saved. However, one or more required items are not completed. Please complete items noted in red.")
        })
      setVariablesForModalClose(null)
    } else {
      console.log("wtf...")
      console.log(variables);
      // neither survey is completed
      handleMutation(variables)
        .then(() => {
          showToast(false, "Your answers are saved. However, one or more required items are not completed. Please complete items noted in red.")
        })
      setVariablesForModalClose(null)
    }
  }

  function handleConfirm(choice) {
    setShowModal(false)
    
    const actualVariables = variablesForModalClose
    if(choice) {
      const dateToStore = new Date()
      actualVariables["completed_date"] = JSON.stringify(dateToStore)
    }
    
    handleMutation(actualVariables)
      .then(() => {
        console.log("inside the then...??")
        if(choice) {
          navigate("/surveys", {replace:true})
        } else {
          showToast(true, "Both sections are saved. You can make any last changes and submit again or you can return to the main surveys table and finalize submission there.")
        }
      })
      .catch(error => {
        console.log("mutation failed: ", error)
      })
  }

  function handleChange(target, value) {
    const updatedValues = { ...values };

    updatedValues[target] = value;

    setValues(updatedValues);

    return;
  }

  function displayQuestion(question, index, maxLength) {
    const useBottomBorder = index !== maxLength - 1;

    let thisQuestionError = {};
    if (errors.length > 0) {
      thisQuestionError = errors.find((error) => {
        return error.name === question.key;
      });
    }

    if (question.type === "boolean") {
      return (
        <BooleanCustom
          handleChange={(name, newValue) => handleChange(name, newValue)}
          label={question.text}
          name={question.key}
          currentValue={values[question.key]}
          trueOption={question.trueOption}
          falseOption={question.falseOption}
          key={`row_${index}`}
          useBottomBorder={useBottomBorder}
          error={thisQuestionError}
          qIndex={index + 1}
        />
      );
    } else if (question.type === "platformQuestion") {
      let content = JSON.parse(JSON.stringify(question));
        content.categories.forEach((category, cIndex) => {
          category.subcategories.forEach((subcategory, sIndex) => {
            let returnObject = subcategory;
            returnObject.currentValue = values[subcategory.key];

            content.categories[cIndex].subcategories[sIndex] = returnObject;
          });
        });

        return (
          <PlatformQuestion
            handleChange={(name, newValue) => handleChange(name, newValue)}
            label={question.text}
            name={question.key}
            key={`row_${index}`}
            content={content}
            useBottomBorder={useBottomBorder}
            error={thisQuestionError}
            qIndex={index + 1}
          />
        );
    } else if (question.type === "singleToggle") {
      return <div>WHY SHOWING SINGLE TOGGLE?</div>;
    } else if (question.type === "string") {
      return (
        <StringInput
          handleChange={(name, newValue) => handleChange(name, newValue)}
          label={question.text}
          name={question.key}
          currentValue={values[question.key]}
          key={`row_${index}`}
          useBottomBorder={useBottomBorder}
          error={thisQuestionError}
          qIndex={index + 1}
        />
      );
    } else if (question.type === "likertInputCustom") {
      return (
        <LikertInputCustom
          handleChange={(name, newValue) => handleChange(name, newValue)}
          label={question.text}
          name={question.key}
          currentValue={values[question.key]}
          values={question.fields}
          key={`row_${index}`}
          useBottomBorder={useBottomBorder}
          error={thisQuestionError}
          qIndex={index + 1}
        />
      );
    } else if (question.type === "likert") {
      return (
        <LikertInput
          handleChange={(target, value) => handleChange(target, value)}
          label={question.text}
          name={question.key}
          currentValue={values[question.key]}
          key={`row_${index}`}
          error={thisQuestionError}
          qIndex={index + 1}
        />
      );
    } else {
      return (
        <div key={`row_${index}`} style={{ borderBottom: useBottomBorder ? "1px solid #ccc" : "" }}>
          <strong>{question.text} lacks a valid type...</strong>
        </div>
      );
    }
  }

  function displayIMI() {
    return imi_questions.map((question, index) => {
      return displayQuestion(question, index, imi_questions.length);
    });
  }

  function displayAssessment() {
    return test_questions.map((question, index) => {
      return displayQuestion(question, index, test_questions.length);
    });
  }

  return (
    <div className='pt-3'>
      <h2>Section 3: General Feedback</h2>
      <p>
        <strong>Instructions:</strong> Please complete the following information for each module/module assessment or
        course posttest you review, at the conclusion of your review. Your feedback will help determine changes to be
        made in current or future courseware.
      </p>
      <p>
        <strong>Note:</strong> If you are reviewing the Course Introduction module, please select “Neither Agree nor
        Disagree” for any questions that are not applicable to that module.
      </p>
      <Form>
        {survey.survey_type == null || survey.survey_type === "imi" || survey.survey_type === "introduction"
          ? displayIMI()
          : displayAssessment()}
        {/* <>{errors.length > 0 && <div className='text-danger mb-3'>Your answers are saved. However, one or more required items are not completed. Please complete items noted in red.</div>}</> */}
        <Button
          color='primary'
          type='button'
          className='mt-2 mb-3'
          onClick={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          Save Section 3
        </Button>
      </Form>
      <Modal
        className="modal-dialog-centered"
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Submit Completed Survey
          </h5>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setShowModal(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">All required survey questions have been answered. Are you ready to submit this survey? After the survey is submitted, no changes can be made. Make and save any desired changes before selecting Submit.</div>
        <div className="modal-footer">
          <Button color="secondary" onClick={() => handleConfirm(false)}>Cancel Submission</Button>
          <Button color="primary" onClick={() => handleConfirm(true)}>Submit Survey</Button>
        </div>
      </Modal>
    </div>
  );
};

export default SurveySectionThree;
